import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

// Pages that live on the main site (auditfriendly.co), not on jobs.auditfriendly.co.
// Links to them sometimes get the wrong host, or pick up trailing text when an email
// client auto-links them (jobs.auditfriendly.co/partners—is), so match on the prefix.
const MAIN_SITE_PAGES: Record<string, string> = {
  "/partners": "https://auditfriendly.co/partners",
  "/advertise": "https://auditfriendly.co/partners#afp-sponsor",
  "/sponsor": "https://auditfriendly.co/partners#afp-sponsor",
};

const mainSiteTarget = (pathname: string) => {
  const path = (() => {
    try {
      return decodeURIComponent(pathname).toLowerCase();
    } catch {
      return pathname.toLowerCase();
    }
  })();
  const hit = Object.keys(MAIN_SITE_PAGES).find((p) => path === p || (path.startsWith(p) && !/[a-z0-9]/.test(path[p.length])));
  return hit ? MAIN_SITE_PAGES[hit] : null;
};

const NotFound = () => {
  const location = useLocation();
  const target = mainSiteTarget(location.pathname);

  useEffect(() => {
    if (target) {
      window.location.replace(location.hash && !target.includes("#") ? target + location.hash : target);
      return;
    }
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname, location.hash, target]);

  if (target) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <Helmet>
        <title>Page Not Found | AuditFriendly</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
